<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Add Documents To Payment Pack</h4>
    </div>

    <p>Select the documents you want to add to the payment pack</p>

    <div class="row">
      <table class="table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Description</th>
            <th>Selected</th>
          </tr>
        </thead>
        <tbody>
          <tr v-bind:key="index" v-for="(document, index) in documents">
            <td>{{ document.type ? document.type.label : 'Not Provided' }}</td>
            <td>{{ document.description }}</td>
            <td>
              <toggleswitch
                :labels="true"
                :name="document.identifier"
                :checked="selected(document)"
                @change="toggle(document)"
              ></toggleswitch>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="saving" v-on:clicked="addDocuments"
        >Add Documents</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    documents: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    }
  },

  computed: {
    paymentPack() {
      return this.$store.getters['Incident/paymentPack'];
    },

    selectedDocuments() {
      if (this.paymentPack && this.paymentPack.documents) {
        return this.paymentPack.documents.map(document => document.identifier);
      }

      return [];
    }
  },

  data() {
    return {
      saving: false
    };
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },

    addDocuments() {
      this.saving = true;

      window.Ajax.post(`payment-pack/${this.incident}/documents`, {
        documents: this.selectedDocuments
      })
        .then(response => {
          window.toastify.success(
            'Success!',
            'The documents were updated successfully'
          );
          this.$store.commit('Incident/setPaymentPack', response.data);
          this.saving = false;
        })
        .catch(() => {
          this.saving = false;
          window.toastify.error(
            'Error',
            'An error occurred while saving the documents'
          );
        });
    },

    selected(document) {
      return this.selectedDocuments.indexOf(document.identifier) > -1;
    },

    toggle(document) {
      if (this.selected(document)) {
        this.selectedDocuments.splice(
          this.selectedDocuments.indexOf(document.identifier),
          1
        );
      } else {
        this.selectedDocuments.push(document.identifier);
      }
    }
  }
};
</script>
